export default "__VITE_ASSET__BjvMbSUh__"